import { useState } from "react"
import { NavLink } from "react-router-dom"
import styled from "styled-components"
import { BlueBtn, BtnBox } from "./contentOwnernship"


const MainBox = styled.div`
@media (min-width: 1024px)
 {
    justify-content: space-between;
}

@media (min-width: 768px)
 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
   
}

    padding-top: 2.25rem;
    padding-bottom: 2.25rem;


    padding-left: 1rem;
    padding-right: 1rem;


    --tw-bg-opacity: 1;
    background-color: rgba(255,255,255,var(--tw-bg-opacity));


   
    justify-content: center;

    align-items: center;


    flex-wrap: wrap;


    flex-direction: row;


    display: flex;

    font-family: sans-serif;

    box-sizing: border-box;

    position: sticky;

    top: -1px;
    
    z-index: 500;
`


const Title = styled.h3`

@media (min-width: 1024px)
 {
    width: auto;
}
@media (min-width: 1024px)
{
    margin-bottom: 0;
}

    --tw-text-opacity: 1;
    color: rgba(97, 97, 97, var(--tw-text-opacity));


    letter-spacing: -0.025em;


    line-height: 1.375;


    font-weight: 600;


    font-size: 1.125rem;
    
    line-height: 1.75rem;

    text-align: center;
    
    margin:0;

    width: 100%;

    margin-bottom: 1.25rem;

    
`

const Btndiv = styled.div`
@media (min-width: 1024px)
{
    justify-content: flex-end;
}
@media (min-width: 1024px)
 {
    width: auto;
}

    justify-content: center;

    flex-direction: row;


    width: 100%;


    display: flex;

`


export const Header = () => {
   
   const [stick, setStick] = useState(false);

   window.addEventListener("scroll", ()=>{
       if(window.scrollY > 0) setStick(true)
       else setStick(false)
   })

   return( 
   <MainBox style={{borderBottom: stick ? "1px solid rgba(0,0,0,.1)":"none"}}>
        <Title>
        Blogging as a developer, done right!
        </Title>
        <Btndiv>
               <NavLink style={{ textDecoration: "none" }} to="/login">
            <BlueBtn style={{marginRight:".75rem",paddingLeft:"1.2rem",paddingRight:"1.2rem", background:"white",color:"black", border:"1px solid rgba(0,0,0,.1)"}}>
                    Login
            </BlueBtn> 
            </NavLink>
            <NavLink style={{textDecoration:"none"}} to="/signup">
                <BlueBtn style={{paddingLeft:"1.2rem",paddingRight:"1.2rem"}}>
                    Create an account
                </BlueBtn>
            </NavLink>
        </Btndiv>
    </MainBox>)
}